<template>
  <div
    class="back-to-top"
    :style="{
      bottom: bottom + 'px',
      right: right + 'px'
    }"
    @click="toTop"
  >
    <mk-iconfont
      class="icon"
      icon-class="huidaodingbu"
    ></mk-iconfont>
    回到顶部
  </div>
</template>
<script>
export default {
  props: {
    refName: {
      type: String,
      default: ''
    },
    right: {
      type: [String, Number],
      default: 40
    },
    bottom: {
      type: [String, Number],
      default: 100
    }
  },
  methods: {
    toTop () {
      // this.$refs.xxx.scrollTop = 0
      this.$emit('to-top')
    }
  }
}
</script>
<style lang="scss" scoped>
  .back-to-top {
    width: 98px;
    height: 32px;
    background-color: #009cff;
    border-radius: 32px;
    text-align: center;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    cursor: pointer;
    position: fixed;
    bottom: 100px;
    right: 40px;
    z-index: 99;

    .icon {
      color: #fff;
      font-size: 12px;
      margin-right: 4px;
    }
  }
</style>
